import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { getDateOperators } from '../../utils/getDateOperators';
import { CustomCell } from './components/custom-cell';

export const TABLE_ORDER_COLUMNS = (modes, groups) => [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Номер заказа',
		field: 'number',
		flex: 1,
		filterOperators: getStringOperators(),
	},
	{
		headerName: 'Группа',
		field: 'group_id',
		flex: 1,
		type: 'singleSelect',
		valueOptions: groups,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.group) {
				return 0;
			}

			return row.group.id;
		},
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Маршрут',
		field: 'way_id',
		flex: 1,
		headerAlign: 'center',
		align: 'center',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Заявка',
		field: 'req_id',
		flex: 1,
		headerAlign: 'center',
		align: 'center',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Статус',
		field: 'status_id',
		flex: 1,
		sortable: false,
		filterable: false,
		type: 'singleSelect',
		valueGetter: (value, row) => {
			if (!row.status) {
				return '';
			}

			return row.status.name;
		},
	},
	{
		headerName: 'Адрес отгрузки',
		field: 'address_from',
		minWidth: 100,
		flex: 1,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Адрес доставки',
		field: 'address_to',
		minWidth: 100,
		flex: 1,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Дата доставки',
		field: 'date_to',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getDateOperators(),
		valueGetter: value => {
			if (!value) {
				return value;
			}

			return new Date(value).toLocaleDateString('ru-RU');
		},
	},
	{
		headerName: 'Т-режим',
		field: 'mode_id',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		sortable: false,
		type: 'singleSelect',
		valueOptions: modes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.id;
		},
		valueFormatter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.name_with_symbol;
		},
	},
	{
		headerName: 'Масса, кг',
		field: 'weight',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Объем, м³',
		field: 'volume',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Места, шт',
		field: 'place',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Стоимость груза',
		field: 'cost',
		flex: 1,
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Примечание',
		field: 'comment',
		flex: 1,
		sortable: false,
		filterOperators: getStringOperators(),
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const NAV_PAGE_LIST = [
	{ text: 'Заказы', href: '/orders' },
	{ text: 'Группировка', href: '/orders_groups' },
	{ text: 'История планирования', href: '/orders_groups_plannings' },
	{ text: 'Автопарки', href: '/orders_groups_autoparks' },
	{ text: 'Импорт', href: '/orders_imports' },
	{ text: 'Черновики', href: '/orders_draft' },
];
